import Vue from 'vue'

export const authGuard = async (to, from, next) => {
  const authService = Vue.prototype.$auth
  const fn = async () => {
    if (authService.isAuthenticated) {
      return next()
    }
    authService.loginWithRedirect(to.fullPath)
  }

  if (!authService.loading) {
    return fn()
  }

  authService.$watch('loading', (loading) => {
    if (loading === false) {
      return fn()
    }
  })
}
